<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Customer to Challenge</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="challengeInput">Challenge</label>
      <select class="custom-select" id="challengeInput" name="challengeInput"
              [(ngModel)]="selectedChallengeId"
              [disabled]="loadingChallenges || (challengeList.length === 0)">
        <option *ngFor="let challenge of challengeList"
                [ngValue]="challenge.id">
          {{ challenge.name }}
        </option>
          <option *ngIf="loadingChallenges"
                  [ngValue]="null"
                  selected>
            Loading...
          </option>
          <option *ngIf="!loadingChallenges && (challengeList.length === 0)"
                  [ngValue]="null"
                  selected>
            No active challenges are available
          </option>
      </select>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
